import { render, staticRenderFns } from "./itemSection.vue?vue&type=template&id=1a10eda8&lang=pug&"
import script from "./itemSection.vue?vue&type=script&lang=js&"
export * from "./itemSection.vue?vue&type=script&lang=js&"
import style0 from "./itemSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports